import { DomainError, ErrorGroup } from 'domain-errors';

export enum LvcErrorCode {
  Undefined = 0,

  CouldNotDecrypt = ErrorGroup.LibVaultCrypto + 500,

  InvalidLength = ErrorGroup.LibVaultCrypto + 400,
  LoadingFromUnknownType = ErrorGroup.LibVaultCrypto + 401,

  InvalidSeedLength = ErrorGroup.LibVaultCrypto + 410,
  InvalidSecondarySeedLength = ErrorGroup.LibVaultCrypto + 411,
  InvalidSaltLength = ErrorGroup.LibVaultCrypto + 412,
  InvalidSecretLength = ErrorGroup.LibVaultCrypto + 413,
  InvalidTotpSecret = ErrorGroup.LibVaultCrypto + 414,
  UnknownTotpAlgorithmError = ErrorGroup.LibVaultCrypto + 415,
  Pkcs8Parse = ErrorGroup.LibVaultCrypto + 416,
}

const pleaseUpdate =
  'We are investigating. In the meantime, make sure you are using the latest version of our software then try again.';

export class LvcDomainError extends DomainError {
  constructor(code: number, short: string, userTitle?: string, userDetail?: string) {
    super(code, short, userTitle ?? short, userDetail ?? pleaseUpdate);
  }
}

export class CouldNotDecryptError extends LvcDomainError {
  constructor() {
    super(
      LvcErrorCode.CouldNotDecrypt,
      'could not decrypt message',
      'Could not decrypt',
      'The client tried to decrypt data using the wrong key.',
    );
  }
}

// TODO: add userTitle and userDetail
export class InvalidLengthError extends LvcDomainError {
  constructor(got: number, want: number) {
    super(LvcErrorCode.InvalidLength, `Found data of length ${got}, expected ${want}.`);
  }
}

// TODO: add userTitle and userDetail
export class LoadingFromUnknownTypeError extends LvcDomainError {
  constructor(type: string) {
    super(LvcErrorCode.LoadingFromUnknownType, `Loading failed from unknown type ${type}}`);
  }
}

// TODO: add userTitle and userDetail
export class InvalidSeedLengthError extends LvcDomainError {
  constructor() {
    super(LvcErrorCode.InvalidSeedLength, 'Seed for derived key must be 32 bytes in length!');
  }
}

// TODO: add userTitle and userDetail
export class InvalidSecondarySeedLengthError extends LvcDomainError {
  constructor() {
    super(
      LvcErrorCode.InvalidSecondarySeedLength,
      'Secondary seed for derived key must be 32 bytes in length!',
    );
  }
}

// TODO: add userTitle and userDetail
export class InvalidSaltLengthError extends LvcDomainError {
  constructor() {
    super(
      LvcErrorCode.InvalidSaltLength,
      'Salt for a derived key must be at least 8 bytes in length!',
    );
  }
}

// TODO: add userTitle and userDetail
export class InvalidSecretLengthError extends LvcDomainError {
  constructor() {
    super(LvcErrorCode.InvalidSecretLength, 'Length of derived secret must be 32 or 64 bytes!');
  }
}

// TODO: add userTitle and userDetail
export class InvalidTotpSecretError extends LvcDomainError {
  constructor() {
    super(LvcErrorCode.InvalidTotpSecret, 'TOTP secret could not be decoded.');
  }
}

export class Pkcs8ParseError extends LvcDomainError {
  constructor(detail: string) {
    super(LvcErrorCode.Pkcs8Parse, `Failed to parse PKCS#8: ${detail}`);
  }
}

export class UnknownTotpAlgorithmError extends LvcDomainError {
  constructor() {
    super(
      LvcErrorCode.UnknownTotpAlgorithmError,
      'TOTP algorithm unknown.',
      'Unknown TOTP algorithm',
      'Your client does not support the requested algorithm. Make sure you are using the latest version of our software then try again',
    );
  }
}
